import React, { Component } from 'react';
import { data } from '../../data/instructor/instructor.js';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/instructor.js';
import { colors } from '../../components/common/element/elements.js';

class Instructor extends Component {
    render() {
        return (
          <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper instructor-page">
              {/* Header 2 */}
              <HeaderTwo />

              {/* Breadcroumb */}
              <BreadcrumbBox title="Instructors" />

              {/* Instructor Area */}
              <section
                style={{ backgroundColor: colors.bg2 }}
                className="instructor-area"
              >
                <Container>
                  <Row>
                    {data.map((item, i) => (
                      <Col lg="3" md="4" sm="6" key={i} className="d-flex">
                        <div className="instructor-item">
                          <a
                            href={item?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="logo-box">
                              <img
                                src={item?.personImage}
                                alt={item?.personName}
                                loading="lazy"
                              />
                            </div>
                            <span className="uni-name">{item.personName}</span>
                          </a>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </section>

              {/* Footer 2 */}
              <FooterTwo />
            </div>
          </Styles>
        );
    }
}

export default Instructor
